import React from 'react';
import MerchantRefundTable from "./components/MerchantRefundTable";
import CustomersRefundTable from "./components/CustomersRefundTable";
const LayoutA = require("../../../dumb/Layout/A");
const {AdminTabs} = require("../../../dumb/Tabs");

module.exports = () => {
  const tabsData = {
    merchant: {
      title: 'Merchant Refunds',
      component: MerchantRefundTable
    },
    customer: {
      title: 'Customer Refunds',
      component: CustomersRefundTable
    }
  };

  return (
    <LayoutA>
      <AdminTabs
        tabsEmitterName="type"
        tabsData={tabsData}
      />
    </LayoutA>
  )
};
